import { Sx } from '@mantine/core';

export function stackedLabelSx(width?: number) {
    return { sx: { width, ['.mantine-Button-label']: { display: 'block', textAlign: 'center', lineHeight: 0.5 } } as Sx };
}
